// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"69":"c16184b3","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"69":"a2a2189584717d235051","245":"2160d693571cc46f950e","452":"591c80c0ee31ba7ac19e","453":"c9a24c9dd3eac3af29db","896":"bf9d880de7f42364d5d2"}[chunkId] + ".js";
};